export const LAST_WORKSPACE_ID = 'lastWorkspaceId';
export const LAST_PROJECT_ID = 'lastProjectId';
export const WORKSPACE_GRAPHIQL = 'workspaceGraphiql';
export const SELECTED_COLUMNS = 'selectedColumns';
export const META_FIELDS = 'metaFieldsExpanded';
export const ENVIRONMENT = 'environment';
export const REDIRECT_TO = 'redirectTo';
export const CALLBACK_URL = 'callbackUrl';
